import { Component } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
})
export class HomeIndexComponent {
  topIconHide: string = 'true';
  LoginName: string = localStorage.aLoginName;
}
